import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Tree } from "antd";
import { fetchTextures } from "../actions";
import categoryList from "./categoryList";

const { TreeNode } = Tree;
const categories = new Map(categoryList);
class NavigatorSidebar extends Component {
  handleSelect = (category, id, children) => {
    if (children) {
      this.props.history.push(`/category/${category}/${id}`);
    } else {
      this.props.history.push(`/textures/${category}/${id}`);
    }
  };

  renderChildren = (level, index, childIndex) => {
    level++;
    let category = categories.get(index);
    if (level > 2) return;
    if (level > 1) {
      category = new Map(categories.get(index).children).get(childIndex);
    }
    if (!category.children) return;

    return category.children.map(([subChildIndex, { category, id, children, count }]) => (
      <TreeNode
        name={category}
        children={children}
        title={
          <span>
            {category}
            {<span style={{ fontSize: ".8em", color: "grey" }}>{` (${count})`}</span>}
          </span>
        }
        key={id}
      >
        {children && this.renderChildren(level, index, id)}
      </TreeNode>
    ));
  };

  renderCategories = () => {
    const level = 0;
    const nodes = [];
    categoryList.forEach(([index, { category, id, children, child, count }]) => {
      if (child) return false;
      nodes.push(
        <TreeNode
          name={category}
          children={children}
          title={
            <span>
              {category}
              {<span style={{ fontSize: ".8em", color: "grey" }}>{` (${count})`}</span>}
            </span>
          }
          key={id}
        >
          {this.renderChildren(level, id)}
        </TreeNode>
      );
    });
    return (
      <Tree.DirectoryTree
        onSelect={(id, info) =>
          this.handleSelect(info.node.props.name, id, info.node.props.children)
        }
        showIcon
      >
        {nodes}
      </Tree.DirectoryTree>
    );
  };

  render() {
    return (
      <div
        style={{
          padding: "10% 10% 10% 10%",
          height: "100%",
          boxShadow: "rgba(0, 0, 0, 0.75) 0px 0px 5px 0px",
          background: "#131313",
        }}
      >
        {this.renderCategories()}
      </div>
    );
  }
}

export default connect(
  null,
  { fetchTextures }
)(withRouter(NavigatorSidebar));



// WEBPACK FOOTER //
// ./src/components/NavigatorSidebar.js